export const donationDetailTour = {
  tourKey: 'donation_detail',
  conditions: {
    orgTypes: ['business'],
    userTypes: null,
    plans: null,
  },
  steps: [
    {
      title: 'tours.donation-detail.welcome.title',
      content: 'tours.donation-detail.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="donation-chat-button"]',
      title: 'tours.donation-detail.chat.title',
      content: 'tours.donation-detail.chat.content',
      placement: 'bottom',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-chat-button"]')),
    },
    {
      target: '[data-tour="donation-repost-option"]',
      title: 'tours.donation-detail.repost.title',
      content: 'tours.donation-detail.repost.content',
      placement: 'bottom',
      autoOpenSelector: '[data-tour="donation-more-actions"]',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-more-actions"]')),
    },
    {
      target: '[data-tour="donation-edit-option"]',
      title: 'tours.donation-detail.edit.title',
      content: 'tours.donation-detail.edit.content',
      placement: 'bottom',
      autoOpenSelector: '[data-tour="donation-more-actions"]',
      showIf: () =>
        Boolean(document.querySelector('[data-tour="donation-more-actions"]')),
    },
  ],
};
